/* eslint-disable no-prototype-builtins */
import axios from 'axios';
import { ShowToast } from 'app/components/atoms';
import { StatusCode } from './';
import * as AuthInterceptor from '../services/interceptor/auth';

const { REACT_APP_API } = process.env;

const axiosInstance = axios.create({
  baseURL: REACT_APP_API
});

// cancel token for cancelling upload file-photo requests
const CancelToken = axios.CancelToken;
export let cancelTokenSource = CancelToken.source();

export const cancelRequests = msg => {
  cancelTokenSource.cancel(msg);
  cancelTokenSource = CancelToken.source();
};

export const responseParser = (fn, resolveBy, rejectBy) => {
  return fn.then(
    response => resolveBy(response),
    error => Promise.reject(rejectBy(error))
  );
};

axiosInstance.setAuthorization = token => {
  axiosInstance.defaults.headers.common['x-access-token'] = token;
};

const responseSuccessInterceptor = response => {
  if (
    response.config.hasOwnProperty('handleNotification') &&
    response.config.handleNotification === true
  ) {
    const status_code = response.data.status_code;
    const successMessage = StatusCode.statusCode[status_code] || 'İşlem başarılı';
    ShowToast('success', successMessage);
  }
  return response;
};

const responseErrorInterceptor = error => {
  // check for refresh token service access while is_active=false and handle renewTokenError
  const err_status_code = error?.response?.data?.status_code;
  if (err_status_code === 1019) {
    // return AuthInterceptor.handleAuthError(axiosInstance, error);
  }

  if (error?.response?.status === 401) {
    return AuthInterceptor.handleAuthError(axiosInstance, error);
    // AuthService.renewToken();
  }

  // check for handleNotification config
  if (
    (error.config.hasOwnProperty('handleNotification') &&
      error?.config?.handleNotification === true) ||
    (error.config.hasOwnProperty('onlyError') && error?.config?.onlyError === true)
  ) {
    // if has response show the error toaster message
    if (error.response) {
      const err_status_code = !!error.response && error.response.data.status_code;
      const errorMessage = StatusCode.statusCode[err_status_code] || 'İşlem başarısız';
      ShowToast('error', errorMessage);
    }
  }

  return Promise.reject(error);
};

axiosInstance.interceptors.request.use(async config => {
  await AuthInterceptor.onRequest(config);
  return config;
});

axiosInstance.interceptors.response.use(responseSuccessInterceptor, responseErrorInterceptor);

export default axiosInstance;
